export { default as ViewProductDetails } from './ViewProductDetails';
export * from './ViewProductDetails';
